// extracted by mini-css-extract-plugin
export default {"productGrid":"EY-z","centerLink":"FY-z","productSection":"GY-z","item":"HY-z","ctaButton":"IY-z"};